import { render, staticRenderFns } from "./JdsTimelineItem.vue?vue&type=template&id=8239b3de&scoped=true&"
import script from "./JdsTimelineItem.vue?vue&type=script&lang=ts&"
export * from "./JdsTimelineItem.vue?vue&type=script&lang=ts&"
import style0 from "./JdsTimelineItem.vue?vue&type=style&index=0&id=8239b3de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8239b3de",
  null
  
)

export default component.exports